import * as React from 'react';
import { MembershipPlanIndexView, MembershipPlanKey } from '../../../../types/membershipPlans';
import classNames from 'classnames';
import './planSelector.module.scss';

export const PlanDetail = ({ durationMonth, basePrice, price, total_price }) => {
  const discount = basePrice * durationMonth - total_price;
  const monthlyPrice = Math.ceil(price / durationMonth);
  const totalMonthlyPrice = Math.ceil(total_price / durationMonth);
  return (
    <div styleName="plan-detail">
      <div styleName="left">
        <div styleName="name">{durationMonth === 1 ? '月額プラン' : `${durationMonth}ヶ月プラン`}</div>
        {discount > 0 && (
          <div styleName={`discount-label duration-${durationMonth}`}>{discount.toLocaleString()}円(税込)お得！</div>
        )}
      </div>
      <div styleName="right">
        {durationMonth > 1 && (
          <div styleName="price-wrapper">
            <div styleName="price-without-tax">
              <div styleName="price">
                月額<span styleName="price-no">{monthlyPrice.toLocaleString()}</span>円
              </div>
            </div>
            <div styleName="price-with-tax">
              <div>（税込 {totalMonthlyPrice.toLocaleString()}円）</div>
              <div>（一括 税込 {total_price.toLocaleString()}円）</div>
            </div>
          </div>
        )}
        {durationMonth === 1 && (
          <div styleName="price-wrapper">
            <div styleName="price-without-tax">
              <div styleName="price">
                <span styleName="price-no">{price.toLocaleString()}</span>円
              </div>
            </div>
            <div styleName="price-with-tax">
              <div>（税込 {total_price.toLocaleString()}円）</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

type Props = {
  selectedKey: MembershipPlanKey;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelectKeyChange: (key: MembershipPlanKey) => any;
  plans: MembershipPlanIndexView[];
};

export const PlanView = ({ selectedKey, onSelectKeyChange, plans }: Props) => {
  const regularPlan = plans.find((p) => p.key === MembershipPlanKey.REGULAR);
  const casualPlan = plans.find((p) => p.key === MembershipPlanKey.CASUAL);
  if (!regularPlan || !casualPlan) {
    return null;
  }
  const selectedPlan = selectedKey === MembershipPlanKey.REGULAR ? regularPlan : casualPlan;
  const planItems = selectedPlan.items.sort((x, y) => -x.duration_month + y.duration_month);
  const basePlanItem = planItems.find((p) => p.duration_month === 1);
  return (
    <div styleName="plan-view">
      <div styleName="plan-list">
        <div
          styleName={classNames('plan-item', { active: selectedKey === MembershipPlanKey.REGULAR })}
          onClick={() => onSelectKeyChange(regularPlan.key)}
        >
          {regularPlan.name}
        </div>
        <div
          styleName={classNames('plan-item', { active: selectedKey === MembershipPlanKey.CASUAL })}
          onClick={() => onSelectKeyChange(casualPlan.key)}
        >
          {casualPlan.name}
        </div>
      </div>
      <div styleName="plan-details">
        {planItems.map((item) => (
          <PlanDetail
            key={item.id}
            durationMonth={item.duration_month}
            price={item.price}
            basePrice={basePlanItem.total_price}
            total_price={item.total_price}
          />
        ))}
      </div>
    </div>
  );
};
